export enum PageType {
  Audio = 'audio',
  Default = 'default',
  Gallery = 'gallery',
  Page = 'page',
  Video = 'video',
}
